<template>
    <div>
        <el-tabs v-model="activeTabName">
            <el-tab-pane name="礼包" label="礼包">
                <GiftPage v-if="activeTabName == '礼包'"/>
            </el-tab-pane>
            <el-tab-pane name="查询兑换码" label="查询兑换码">
                <QueryRedeemCodeDetailsPage v-if="activeTabName == '查询兑换码'"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import GiftPage from "./RedeemCodeGiftPage";
import QueryRedeemCodeDetailsPage from "./QueryRedeemCodeDetailsPage";

export default {
    data() {
        return {
            activeTabName: "礼包",
        };
    },

    components: {
        GiftPage,
        QueryRedeemCodeDetailsPage,
    },
}
</script>